import { isPast } from 'date-fns';
import { cn } from '@streetferret/utils';
import { DateTime } from '@streetferret/ui-web/typography/date-time';
import { DurationLong } from '@streetferret/ui-web/typography/duration-long';

interface DateRangeProps {
  start: Date;
  end: Date;
  className?: string;
  withDuration?: boolean;
}
export function DateRange({
  start,
  end,
  className,
  withDuration,
}: DateRangeProps) {
  const hasStarted = isPast(start);
  const hasEnded = isPast(end);

  const isOngoing = hasStarted && !hasEnded;

  if (isOngoing) {
    return (
      <span className={cn(className)}>
        <DateTime date={start} /> - Now
      </span>
    );
  }

  if (!hasStarted) {
    return (
      <span className={cn(className)}>
        Starting <DateTime date={start} />
      </span>
    );
  }

  return (
    <span className={cn(className)}>
      <DateTime date={start} hideTime /> - <DateTime date={end} hideTime />
      {withDuration && (
        <span className="ml-1">
          (<DurationLong start={start} end={end} />)
        </span>
      )}
    </span>
  );
}
